module.exports = __webpack_public_path__ + "assets/img/fermented_dough_active.ee619ed9.png";